export default {
  title: 'Este restaurante ainda não pode entrar em funcionamento',
  description:
    'A sua conta de parceiro não tem taxa de processamento para pagamentos online nem confirmou uma margem de 0%. O Stripe cobra as suas taxas à sua plataforma, pelo que é necessário decidir uma das duas opções primeiro.',
  partner_action:
    'Defina uma taxa de processamento predefinida ou confirme que não cobra nada aos seus restaurantes e que paga você as taxas do Stripe.',
  ask_partner:
    'O seu parceiro ainda não definiu a taxa de processamento para pagamentos online. Este restaurante poderá entrar em funcionamento assim que o fizer.',
  buttons: {
    set_rate: 'Definir taxa de processamento',
    close: 'Fechar',
  },
};
